<script setup>

import MainFooter from '@/components/partial/MainFooter.vue'
import {computed, ref} from 'vue'
import {Dictionary, Funds, MySelf, Regions} from '@/common/api.service'
import {useRoute, useRouter} from 'vue-router'
import ValidateInput from '@/components/validate/input.vue'
import {useToast} from 'vue-toastification'
import moment from 'moment'
import Shared from '@/common/shared'

const route = useRoute()
const router = useRouter()
const toast = useToast()
const item = ref({})
const supportedIndustries = ref([])
const targetedUses = ref([])
const fund = ref({})
const region = ref({})
const itemFields = ref([])
const dbl = ref(0)
const ownProgramStatuses = ref([])
const targetedUsesCustom = ref(null)

const setRef = (el) => {
  itemFields.value.push(el)
}

const permissions = ref([])
const isRegionalFundEmployee = ref(false)
await MySelf.card().then(async ({data}) => {
  isRegionalFundEmployee.value = data.isRegionalFundEmployee
})

await Regions.permissions()
    .then(async ({data}) => {
      permissions.value = data
    }).catch(async () => {
      await router.push({name: 'Error'})
    })

function permission(permission) {
  return permissions.value.find((p) => p === permission)
}

const isEditField = ref(false)
if (permission('/funds/own-programs:update') || permission('/funds/own-programs:create')) {
  isEditField.value = true
}

await Regions.item(route.params.id)
    .then(({data}) => {
      window.scrollTo(0, 0)
      region.value = data
    }).catch(async (data) => {
      if (data.response && data.response.status === 403) {
        await router.push({name: 'ForbiddenPage'})
      }
    })
await Funds.item(region.value.fund.id)
    .then(({data}) => {
      fund.value = data
    }).catch(() => {
    })

if (route.params.own) {
  await Funds.ownPrograms(fund.value.id)
      .then(({data}) => {
        item.value = data.find(i => i.id === route.params.own)
        let s = []
        for (let i = 0; i < item.value.supportedIndustries.length; i++) {
          s.push(item.value.supportedIndustries[i].value)
        }
        item.value.supportedIndustries = s
        let u = []
        for (let i = 0; i < item.value.targetedUses.length; i++) {
          u.push(item.value.targetedUses[i].value)
        }
        item.value.targetedUses = u

        if (item.value.gispCardUrl) {
          item.value.gispCardUrl = decodeURI(item.value.gispCardUrl)
        }
        if (item.value.rfrpCardUrl) {
          item.value.rfrpCardUrl = decodeURI(item.value.rfrpCardUrl)
        }

      }).catch(() => {
      })
}

function decodeURLAllFields() {
  if (item.value.gispCardUrl) {
    item.value.gispCardUrl = decodeURI(item.value.gispCardUrl)
  }

  if (item.value.rfrpCardUrl) {
    item.value.rfrpCardUrl = decodeURI(item.value.rfrpCardUrl)
  }
}

await Dictionary.supportedIndustries()
    .then(({data}) => {
      supportedIndustries.value = data
    }).catch(() => {
    })

await Dictionary.targetedUses()
    .then(({data}) => {
      targetedUses.value = data
    }).catch(() => {
    })

await Dictionary.ownProgramStatuses()
    .then(({data}) => {
      ownProgramStatuses.value = data
      if (!item.value.status) {
        item.value.status = ownProgramStatuses.value[0].value
      }
    }).catch(() => {
    })

const supportedIndustriesList = computed(() => {
  let r = []
  supportedIndustries.value.forEach(function (f) {
    r.push({value: f.value, label: `${f.title}`})
  })

  return r
})

const targetedUsesList = computed(() => {
  let r = []
  targetedUses.value.forEach(function (f) {
    r.push({value: f.value, label: `${f.title}`})
  })

  return r
})

async function save() {
  let isValid = true
  itemFields.value.forEach((f) => {
    if (f === null) {
      return
    }
    f.validate()
    if (f.validationFailed) {
      isValid = false
    }
  })
  if (item.value.targetedUses && item.value.targetedUses.find(v => v === targetedUsesList.value.find(l => l.label === 'Иное').value)) {
    targetedUsesCustom.value.validate()
    if (targetedUsesCustom.value.validationFailed) {
      isValid = false
    }
  }
  if (isValid) {
    if (item.value.status) {
      item.value.status = parseInt(item.value.status)
    }

    if (item.value.gispCardUrl) {
      item.value.gispCardUrl = decodeURI(item.value.gispCardUrl)
    } else {
      item.value.gispCardUrl = null
    }

    if (item.value.rfrpCardUrl) {
      item.value.rfrpCardUrl = decodeURI(item.value.rfrpCardUrl)
    } else {
      item.value.rfrpCardUrl = null
    }

    if (!item.value.id) {
      await postNew()
    } else {
      await post()
    }
  } else {
    dbl.value++
    toast.error('Программа не сохранена, проверьте обязательные поля', {
      timeout: 5000
    })
  }
}

async function postNew() {
  await Funds.createOwnPrograms(fund.value.id, item.value).then(async () => {
    await router.push({name: 'CardRegions', params: {id: route.params.id}})
  }).catch((response) => {
    dbl.value++
    toast.error(response.response.data.title, {
      timeout: 5000
    })
  })
}

async function post() {
  await Funds.updateOwnPrograms(fund.value.id, item.value.id, item.value).then(async () => {
    await router.push({name: 'CardRegions', params: {id: region.value.id}})
  }).catch((response) => {
    dbl.value++
    toast.error(response.response.data.title, {
      timeout: 5000
    })
  })
}

async function showRemove() {
  Shared.showModal('#del-document')
}

async function closeRemove() {
  Shared.closeModal('#del-document')
}

async function remove() {
  await Funds.removeOwnPrograms(fund.value.id, item.value.id).then(async () => {
    Shared.closeModal('#del-document')
    Shared.showModal('#close-document')
  }).catch(({response}) => {
    Shared.closeModal('#del-document')
    if (response.data.title) {
      toast.error(response.data.title, {
        timeout: 5000
      })
    } else {
      toast.error('Ошибка удаления программы', {
        timeout: 5000
      })
    }
  })
}

async function close() {
  Shared.closeModal('#close-document')
  await router.push({name: 'CardRegions', params: {id: region.value.id}})
}

</script>

<template>
  <div class="wrapper">
    <MainHeader></MainHeader>
    <main class="page page--js">
      <div class="breadcrumbs-container">
        <div class="container">
          <div class="breadcrumbs-wrapper">
            <ul class="breadcrumbs">
              <li>
                Модуль регионов
              </li>
              <li v-if="!isRegionalFundEmployee">
                <router-link
                    :to="{name: 'ListRegions'}">Список регионов
                </router-link>
              </li>
              <li v-else>Список регионов</li>
              <li>
                <router-link
                    :to="{name: 'CardRegions', params: { id: fund.region.id}}">
                  {{ fund.region.title }}
                </router-link>
              </li>
              <li v-if="item.id">Самостоятельная программа "{{ item.title }}"</li>
              <li v-else>Добавление самостоятельной программы</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="container">
          <div class="content__wrapper">
            <div class="content__contract">
              <div class="content__title content__title--contract">
                <h1 class="title title-h1--contract" v-if="!item.id">Добавление самостоятельной программы</h1>
                <h1 class="title title-h1--contract" v-else>{{ fund.shortTitle }}, Самостоятельная программа
                  "{{ item.title }}"</h1>
              </div>
              <form action="#" class="contract">
                <div class="contract__row">
                  <div class="contract__item">
                    <ValidateInput
                        :name="'Название самостоятельной программы'"
                        placeholder="Введите название программы"
                        :ref="setRef"
                        required
                        maxlength="255"
                        :disabled="!isEditField"
                        v-model="item.title">
                    </ValidateInput>
                    <ValidateInput
                        :name="'Описание программы'"
                        placeholder="Введите описание программы"
                        :ref="setRef"
                        required
                        textarea
                        maxlength="2000"
                        :disabled="!isEditField"
                        v-model="item.description">
                    </ValidateInput>
                    <ValidateInput
                        label-class="title-field title-field--relative"
                        :name="'Поддерживаемые отрасли'"
                        :ref="setRef"
                        required
                        nonEmptyArray
                        v-model="item.supportedIndustries">
                      <template v-slot:field="{validationFailed}">
                        <Multiselect
                            placeholder="Введите название отрасли"
                            class="field field--select select-height-max-88" style="height: auto"
                            v-model="item.supportedIndustries"
                            :class="{unvalidate: validationFailed}"
                            mode="tags"
                            :disabled="!isEditField"
                            :searchable="true"
                            :close-on-select="false"
                            :hide-selected="false"
                            :options="supportedIndustriesList"
                            :can-clear="false"
                            ref="msi"
                        />
                        <div>
                          <a href="#" class="own-select-control__item" @click.prevent="$refs.msi.selectAll();">Выбрать все</a> /
                          <a href="#" class="own-select-control__item" @click.prevent="$refs.msi.clear();">Очистить всё</a>
                        </div>
                      </template>
                    </ValidateInput>
                    <ValidateInput
                        label-class="title-field title-field--relative"
                        :name="'Направление целевого использования'"
                        :ref="setRef"
                        required
                        nonEmptyArray
                        v-model="item.targetedUses">
                      <template v-slot:field="{validationFailed}">
                        <Multiselect
                            placeholder="Введите название направления целевого использования"
                            class="field field--select select-height-max-88" style="height: auto"
                            v-model="item.targetedUses"
                            :class="{unvalidate: validationFailed}"
                            mode="tags"
                            :searchable="true"
                            :aria-expanded="true"
                            :close-on-select="false"
                            :hide-selected="false"
                            :disabled="!isEditField"
                            :options="targetedUsesList"
                            :can-clear="false"
                            ref="tum"
                        />
                        <ValidateInput
                            ref="targetedUsesCustom"
                            placeholder="Введите название направления целевого использования"
                            v-if="targetedUsesList && item.targetedUses && item.targetedUses.find(v => v === targetedUsesList.find(l => l.label === 'Иное').value)"
                            required
                            maxlength="255"
                            :disabled="!isEditField"
                            v-model="item.targetedUsesCustom">
                        </ValidateInput>
                        <div class="own-select-control">
                          <a href="#" class="own-select-control__item" @click.prevent="$refs.tum.selectAll();">Выбрать все</a> /
                          <a href="#" class="own-select-control__item" @click.prevent="$refs.tum.clear();">Очистить всё</a>
                        </div>
                      </template>
                    </ValidateInput>
                    <ValidateInput
                        :name="'Ссылка на карточку ГИСП'"
                        placeholder="Введите URL адрес"
                        :ref="setRef"
                        url
                        notRequired
                        maxlength="1024"
                        :disabled="!isEditField"
                        v-model="item.gispCardUrl"
                        @change="decodeURLAllFields">
                    </ValidateInput>
                    <ValidateInput
                        :name="'Ссылка на карточку РФРП'"
                        placeholder="Введите URL адрес"
                        :ref="setRef"
                        url
                        notRequired
                        maxlength="1024"
                        :disabled="!isEditField"
                        v-model="item.rfrpCardUrl"
                        @change="decodeURLAllFields">
                    </ValidateInput>
                  </div>
                  <div class="contract__item">
                    <ValidateInput
                        :name="'Срок займа, диапазон лет'"
                        required
                        placeholder="Введите диапазон срока займа"
                        :ref="setRef"
                        maxlength="50"
                        :disabled="!isEditField"
                        v-model="item.loanDuration">
                    </ValidateInput>
                    <div class="interval-fields">
                      <ValidateInput
                          :name="'Сумма займа, млн руб.'"
                          required
                          number
                          placeholder="Введите минимальную сумму"
                          maxlength="16"
                          :float-format="2"
                          :disabled="!isEditField"
                          :ref="setRef"
                          v-model="item.loanSumMin">
                      </ValidateInput>
                      <span></span>
                      <ValidateInput
                          :name="''"
                          required
                          number
                          placeholder="Введите максимальную сумму"
                          maxlength="16"
                          :float-format="2"
                          :disabled="!isEditField"
                          :ref="setRef"
                          v-model="item.loanSumMax">
                      </ValidateInput>
                    </div>
                    <ValidateInput
                        :name="'Ставка, %'"
                        required
                        placeholder="Введите ставку в процентах"
                        :ref="setRef"
                        maxlength="255"
                        :disabled="!isEditField"
                        v-model="item.rate">
                    </ValidateInput>
                    <ValidateInput
                        :name="'Софинансирование, %'"
                        required
                        placeholder="Введите софинансирование в %"
                        maxlength="255"
                        :ref="setRef"
                        :disabled="!isEditField"
                        v-model="item.cofinanceRate">
                    </ValidateInput>
                    <ValidateInput
                        :name="'Минимальный бюджет заявки, млн руб'"
                        required
                        placeholder="Введите минимальный бюджет заявки"
                        :ref="setRef"
                        maxlength="255"
                        :disabled="!isEditField"
                        v-model="item.commonBudget">
                    </ValidateInput>
                    <ValidateInput
                        :name="'Статус'"
                        select
                        required
                        placeholder="Статус"
                        :ref="setRef"
                        :items="ownProgramStatuses"
                        :item-key="'value'"
                        :item-name="'title'"
                        :disabled="!isEditField"
                        v-model="item.status">
                    </ValidateInput>
                    <ValidateInput
                        :name="'Комментарий'"
                        placeholder="Введите комментарий"
                        :ref="setRef"
                        textarea
                        :disabled="!isEditField"
                        v-model="item.comment">
                    </ValidateInput>
                  </div>
                </div>
                <div class="contract__row" v-if="item.id">
                  <div class="entry-info entry-info--width50">
                    <div class="entry-info__item">Дата создания
                      записи:<span>{{ moment(item.createdAt).format('DD.MM.YYYY HH:mm:ss') }}</span></div>
                    <div class="entry-info__item">Создание записи, кем:<span>{{ item.creator.shortName }}</span>
                    </div>
                    <div class="entry-info__item">Дата изменения
                      записи:<span>{{ moment(item.modifiedAt).format('DD.MM.YYYY HH:mm:ss') }}</span></div>
                    <div class="entry-info__item">Изменение записи, кем:<span>{{ item.modifier.shortName }}
                                            </span></div>
                  </div>
                </div>
                <div class="buttons-block buttons-block--right">
                  <button type="button"
                          class="button button--delete"
                          v-if="item.id && permission('/funds/own-programs:delete')"
                          @click="showRemove">
                    Удалить
                  </button>
                  <router-link :to="{ name: 'CardRegions', params: { id: region.id } }" class="button button--clear">
                    <template v-if="permission('/funds/own-programs:update')">Отмена изменений</template>
                    <template v-else>Закрыть</template>
                  </router-link>
                  <button
                      type="button"
                      class="button"
                      :key="dbl"
                      v-if="permission('/funds/own-programs:update')"
                      @click.once="save">сохранить
                  </button>
                </div>
              </form>
              <div>
                Поля, помеченные знаком «*», являются обязательными для заполнения.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-overlay" id="del-document">
        <div class="popup popup-del">
          <div class="modal-title">Удаление записи</div>
          <div class="modal-body">Вы действительно хотите удалить самостоятельную программу?</div>
          <div class="modal-bottom">
            <div class="buttons-block button-dialog-center">
              <button type="button" class="button button--clear close-modal--js" @click="closeRemove">Закрыть</button>
              <button type="button" class="button button--delete sub-modal-open--js"
                      data-modal="close-document" @click="remove">Удалить
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-overlay" id="close-document">
        <div class="popup">
          <div class="modal-title">Запись удалена</div>
          <div class="modal-body"></div>
          <div class="modal-bottom">
            <div class="buttons-block">
              <button type="button" class="button button--clear close-modal--js" @click="close">Закрыть</button>
            </div>
          </div>
        </div>
      </div>
    </main>
    <MainFooter></MainFooter>
  </div>
</template>

<style scoped>

</style>